/**
 * Semantic color roles for MyHoreca Pay UI.
 * Components consume roles, not raw hex — except documented brand exceptions (bank logos).
 */
export const semanticColors = {
  canvas: '#f8fafc',
  surface: '#ffffff',
  surfaceRaised: '#ffffff',
  surfaceMuted: '#f1f5f9',
  surfaceSelected: '#eff6ff',
  surfaceDisabled: '#f8fafc',

  border: '#e2e8f0',
  borderStrong: '#cbd5e1',
  borderSubtle: '#f1f5f9',

  textPrimary: '#0f172a',
  textSecondary: '#334155',
  textMuted: '#64748b',
  textDisabled: '#94a3b8',
  textOnAccent: '#ffffff',

  actionPrimary: '#2563eb',
  actionPrimaryHover: '#1d4ed8',
  actionPrimaryActive: '#1e40af',
  actionSecondary: '#dbeafe',
  actionSecondaryHover: '#bfdbfe',

  focusRing: '#2563eb',

  success: '#158f49',
  successSoft: '#e9fbf0',
  warning: '#ad7100',
  warningSoft: '#fff8e5',
  danger: '#c51f33',
  dangerSoft: '#fff0f1',
  info: '#2454c7',
  infoSoft: '#eef4ff',
  neutral: '#475569',
  neutralSoft: '#f1f5f9',

  sidebarBackground: '#182236',
  sidebarSurface: '#101827',
  sidebarText: '#f8fafc',
  sidebarTextMuted: 'rgba(248, 250, 252, 0.72)',
  sidebarSelected: 'rgba(255, 255, 255, 0.14)',
  sidebarSelectedText: '#ffffff',

  overlay: 'rgba(15, 23, 42, 0.45)',
} as const;

export type SemanticColorRole = keyof typeof semanticColors;
